import { useHasPermission } from './useHasPermission';

export const useCanAccessUsersResource = () => {
  const hasPeopleAccess = useHasPermission('PEOPLE_ACCESS');
  const canManageUsers = useHasPermission({
    someOf: ['ADMIN_ACCESS', 'UNIT_EMPLOYEES_EDIT'],
  });

  return hasPeopleAccess && canManageUsers;
};
